<div
  class="h-[7px] w-full overflow-hidden rounded-full bg-slate200"
  role="progressbar"
  aria-label="Progress"
  aria-valuemin="0"
  aria-valuemax="100"
  [attr.aria-valuenow]="progress"
>
  <div
    class="h-full rounded-full bg-indigo600 transition-all duration-300 ease-out"
    [style.width.%]="progress"
  ></div>
</div>
